import * as React from "react";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {BackButton} from "../../../../../components/navigation/BackButton";
import FalconFooter from "../../../../../components/navigation/FalconFooter";
import {FalconNavigatorHeader, resourcesHelper} from "@falcon/services";
import {AllianzOnlineBadge} from "../../../../../components/AllianzOnlineBadge";
import {IWithRouterProps, withRouter} from "@athena-portal/components";

interface IAllOtherMotorClaimsPageParams {
    policyNumber: string;
    [key: string]: string | undefined
}

export class AllOtherMotorClaimsPagePlain extends React.Component<IWithRouterProps<IAllOtherMotorClaimsPageParams>> {

    public render() {
        const isBritanniaBrand = ["bn", "britannia"].includes((resourcesHelper.THEME || "").toLowerCase());
        const claimTitle = "All other claims";

        return (
            <React.Fragment>
                <FalconHeader/>
                <div className="page-contents dashboard-page">
                    <AllianzOnlineBadge/>
                    <FalconNavigatorHeader
                        back={`/dashboard/pickAnnualMotorClaimKind/${this.props.params.policyNumber}`}
                        title={
                            isBritanniaBrand
                                ? {
                                    html: (
                                        <div className="text-group title plugin no-indent-desktop">
                                            <h1 className="m-0">
                                                <span>All other </span>
                                                <span className="claim-highlight">claims</span>
                                            </h1>
                                        </div>
                                    )
                                }
                                : claimTitle
                        }
                    />
                    <div className="panel claim-page reset-margins">
                        <div className="dl-widget-video-panel">
                            <img className="claims-icon" src={`/${resourcesHelper.THEME}/img/make-a-claim.png`} alt="Make a claim icon"/>
                        </div>

                        <p className="mt-4 mb-4 font-weight-bold text-center claim-text">
                            For any claims on your car(s) call our 24 hour helpline
                        </p>

                        <div className="text-center mb-4">
                            <a
                                href="tel:+443306781476"
                                className="mb-4 no-underline font-weight-semi-bold icon-phone-before margin-top-10"
                                id="claimsPagePhoneLink"
                                aria-label="Phone number (+44) 330 678 1476"
                            >
                                (+44) 330 678 1476
                            </a>
                        </div>

                        <p className="text-center margin-top-10">
                            Lines open {isBritanniaBrand ? <strong>24 hours, 7 days a week.</strong> : "24 hours, 7 days a week."}{' '}
                            Calls will be recorded. For Text Phone, first dial 18001
                        </p>
                    </div>

                    <BackButton isTop={false} link={`/dashboard/pickAnnualMotorClaimKind/${this.props.params.policyNumber}`}/>
                </div>
                <FalconFooter/>
            </React.Fragment>
        );
    }
}

export const AllOtherMotorClaimsPage = withRouter<{}, IAllOtherMotorClaimsPageParams>(AllOtherMotorClaimsPagePlain);
